import { getAccountListApi } from '@/api/copyright/common'
export default {
    data () {
        return {
            // 账号数组
            accountList: [],
        }
    },
    methods: {
        getAccountList () {
            return new Promise((resolve, reject) => {
                getAccountListApi().then((res) => {
                    if (res.code === 200) {
                        let accountList = []
                        let list = res.data && res.data.accountList ? res.data.accountList : []
                        list.map(item => {
                            // 状态 0. 未激活 1. 正常用户 2.禁用 3. 注销 4. 异常状态用户
                            if (item.status !== 3) {
                                accountList.push({
                                    label: item.account,
                                    value: item.userId
                                })
                            }
                        })
                        this.accountList = accountList
                        resolve()
                    }
                }).catch((err) => {
                    reject(err)
                });
            })
        }
    }
}